import StorageKeys from "../../const/StorageKeys";
import ApiService from "../../service/api/ApiService";
import ApiUrls from "../../service/api/ApiUrls";
import { navigate } from "../../service/navigation/Navigation";
import CacheStorage from "../../service/storage/CacheStorage";
import ShowToast from "../../widget/common/ui/Toast";

const DeactivateAccountProvider = new (class DeactivateAccountProvider {
  navigate = (url: any) => {
    navigate(url);
  };

  deactiveProfileAPI = async (
    reason: string,
    password: string
  ): Promise<boolean> => {
    ApiUrls.init();

    const deviceId: string = CacheStorage.getValue(StorageKeys.device_id);
    const appId: string = CacheStorage.getValue(StorageKeys.app_id);
    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}profile/delete_profile`;

    const body: any = {
      account_id: accountId,
      app_id: appId,
      device_id: deviceId,
      delete_reason: reason,
      password: password,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        CacheStorage.saveValue(
          StorageKeys.app_id,
          response["result"]["device_details"]["app_id"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.api_token,
          response["result"]["device_details"]["api_token"].toString()
        );
        CacheStorage.saveValue(
          StorageKeys.refresh_token,
          response["result"]["device_details"]["refresh_token"].toString()
        );

        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default DeactivateAccountProvider;
